module.exports = __webpack_public_path__ + "img/advantage4Green.26db2efd.png";